<ng-container *ngFor="let banner of banners">
 <section class="col-xs-12 wonderfluimg" id="home_loginsection" role="img" aria-label="Healthcare professional silhouette" style="background-image: url('{{getImage(banner?.media)}}');">
    
    </section>

    
</ng-container>


